/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Choice from 'DesignSystem/Choice/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Item({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/Choice/Options/Item"
  
}) {
let questionAnswerValueValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'answer.value',
})
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let questionOptionTextValueData = fromData.useDataValue({ viewPath,
context: 'question_option',
path: 'text',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.populateTemplate(widgetQuestionsValueData, questionOptionTextValueData, selectedAnswersValueData)
let questionOptionIdValueData = fromData.useDataValue({ viewPath,
context: 'question_option',
path: 'id',
})
let questionTextTransformValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'textTransform',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtChoiceBackgroundcolorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.backgroundColor.brand.base'
        })
let dtChoiceBackgroundcolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.backgroundColor.brand.hovered'
        })
let dtChoiceBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.backgroundColor.brand.selected'
        })
let dtChoiceBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.borderColor.brand.hovered'
        })
let dtChoiceBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.borderColor.brand.selected'
        })
let dtChoiceColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Choice.color.brand.hovered'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Choice
  viewPath={`${viewPath}/Choice`}
 onClick={onClick}
 data="question.answer.value"
 selected={questionAnswerValueValueData}
 data="widget.questions"
 data="question_option.text"
 data="selected.answers"
 aggregate="./helpers.js populateTemplate"
 text={aggregateData}
 data="question_option.id"
 id={questionOptionIdValueData}
 fontSize={dtTypographyFontsizeM}
 backgroundColor={dtChoiceBackgroundcolorBrandBase}
 backgroundColorHovered={dtChoiceBackgroundcolorBrandHovered}
 backgroundColorSelected={dtChoiceBackgroundcolorBrandSelected}
 borderColorHovered={dtChoiceBordercolorBrandHovered}
 borderColorSelected={dtChoiceBordercolorBrandSelected}
 colorHovered={dtChoiceColorBrandHovered}
 data="question.textTransform"
 textTransform={questionTextTransformValueData}
/>
{children}
</React.Fragment>)
}